<template lang="pug">
  el-menu-item(
    index='/rent_tariffs'
    v-if=`
          showItemDynamically(user, dynamicViewsConstants.resource_names.RENT_TARIFF, ['index']) &&
          !showItemDynamically(user, dynamicViewsConstants.resource_names.DOCKING_STATION, ['show_statistics', 'index'])
      `
  )
    .img-wrapper
      img(src="@src/assets/sidebar/stations.svg")
    router-link.sub-menu-link(to="/rent_tariffs")
      span  {{ $t('sidebar.rent_tariffs') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "RentTariffsItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
